export const DEEP_LINK_HASH_PARAM = 'deeplink=';
export const DEEP_LINK_QUERY_PARAM = 'deeplink';